import { TYPES_PLANS } from "#/constants";
import { BaseBeneficiary, Product } from "#/types";
import { ApiService } from "./apiService";

export default class ProductService extends ApiService {
  constructor(accessToken: string) {
    super("/product", accessToken);
  }

  // Busca os dados básicos dos planos disponíveis
  getProducts(): Promise<Product[]> {
    return this.get("");
  }

  // Verifica a elegibilidade do dependente
  checkDependentElegibility(
    product: TYPES_PLANS,
    dependent: BaseBeneficiary
  ): Promise<Product[]> {
    return this.post(`/${product}/dependent/eligible`, dependent);
  }

  // adiciona dependentes
  addDependents(
    product: TYPES_PLANS,
    insuranceNumber: string,
    dependent: BaseBeneficiary
  ): Promise<Product[]> {
    return this.post(
      `/${product}/insurance/${insuranceNumber}/dependent`,
      dependent
    );
  }

  // deleta um dependente
  deleteDependent(
    product: TYPES_PLANS,
    insuranceNumber: string,
    indentifier: string
  ): Promise<Product[]> {
    return this.delete(
      `/${product}/insurance/${insuranceNumber}/dependent/${indentifier}`
    );
  }
}
